import { render, staticRenderFns } from "./ConnectLexoffice.vue?vue&type=template&id=0d20fcbc&scoped=true&"
import script from "./ConnectLexoffice.vue?vue&type=script&lang=js&"
export * from "./ConnectLexoffice.vue?vue&type=script&lang=js&"
import style0 from "./ConnectLexoffice.vue?vue&type=style&index=0&id=0d20fcbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d20fcbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VTextField})
